import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';
import './Profile.css';
import { NavLink } from "react-router-dom";

const ProfileSideBar = () => {
  const dispatch = useDispatch();
  const menuItems = [
    { text: "Profile", link: "/profile" },
    { text: "Address", link: "/address" },
    { text: "Orders", link: "/orders" },
    // { text: "Logout", link: "/login" }
  ];
  const handleLogout = () => {

    dispatch(logout());
  };
  return (
    <div className="row">
      {menuItems.map((item, index) => (
        <div key={index} className="col-md-12 mb-3">
          <NavLink
            to={item.link}
            className={({ isActive }) =>
              `btn btn-white btn-outline-white w-100 py-3 px-xl-4 rounded-1 ${isActive ? "active-button" : ""
              }`
            }
          >
            {item.text}
          </NavLink>

        </div>
      ))}
      <div className="col-md-12 mb-3">
        <NavLink
          to="/"
          className="btn btn-white btn-outline-white w-100 py-3 px-xl-4 rounded-1"

          onClick={handleLogout}
        >
          logout
        </NavLink>
      </div>
    </div>
  );
};

export default ProfileSideBar;